import axios, { AxiosResponse } from "axios";
import { ServerModelWithDateStrings } from "@teamprevent/common/utils";

import * as moment from "moment";

import { OhCaseDocument } from "./model";

const apiUrl = (customerId: string, ohCaseId: string) => `/api/customer/${customerId}/case/${ohCaseId}/document`;

const parseModel = (model: ServerModelWithDateStrings<OhCaseDocument>): OhCaseDocument => {
    return {
        ...model,
        dateCreated: model.dateCreated ? moment(model.dateCreated) : undefined
    };
};

const getAll = async (customerId: string, ohCaseId: string): Promise<OhCaseDocument[]> => {
    const response = await axios.get<
            undefined,
            AxiosResponse<ServerModelWithDateStrings<OhCaseDocument>[]>
        >(apiUrl(customerId, ohCaseId));
    return response.data.map(parseModel);
};

const getCount = async (customerId: string, ohCaseId: string): Promise<number> => {
    const response = await axios.get<number>(`${apiUrl(customerId, ohCaseId)}/count`);
    return response.data;
};

const deleteDocument = async (customerId: string, ohCaseId: string, ohCaseDocumentId: string): Promise<void> => {
    await axios.delete(`${apiUrl(customerId, ohCaseId)}/${ohCaseDocumentId}`);
};

const updateVisibilitySetting = async (customerId: string, ohCaseId: string, ohCaseDocumentId: string, visibleTo: string, sendEmailNotifications: boolean) => {
    const response = await axios.put(`${apiUrl(customerId, ohCaseId)}/${ohCaseDocumentId}/updateDocumentVisibility`, { visibleTo, sendEmailNotifications });

    return response.data;
};

export const OhCaseDocumentApi = { getAll, getCount, deleteDocument, updateVisibilitySetting, parseModel };

